module.exports = __webpack_public_path__ + "img/744.c2b35a8c.jpg";